module.exports = "<div class=form-field> <div ng-if=!$ctrl.hideLabel ng-class=[$ctrl.labelClass] class=form-field-label> {{ $ctrl.label }} </div> <div ng-class=[$ctrl.inputClass] class=form-field-input> <custom-typeahead empty-display-name=$ctrl.emptyDisplayName item-display-prop=$ctrl.displayProp item-list=$ctrl.itemList on-item-select=\"$ctrl.setItem({item: item})\" selected-display=$ctrl.selectedItem clear-after-select=$ctrl.clearAfterSelect> </custom-typeahead> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/form-fields/typeahead-field/typeahead-field.html
// module id = 350
// module chunks = 0